module.exports = __webpack_public_path__ + "static/media/tma-logo-white.99eb2df8.png";